export default __webpack_public_path__ + "static/media/deliland-ugu-icon.37f99c72.png";